import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-lg font-bold whitespace-nowrap transition-colors duration-300 ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            羊宫妃那词条百科
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? scrolled
                      ? 'bg-foreground-100 text-foreground-950'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-foreground-50'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                scrolled
                  ? 'text-foreground-600 hover:text-foreground-950'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-foreground-100">
          <div className="px-4 py-3 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`block px-3 py-2.5 text-sm rounded-lg transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-foreground-100 text-foreground-950 font-medium'
                    : 'text-foreground-700 hover:bg-foreground-50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <hr className="my-2 border-foreground-100" />
            <Link
              to="/about"
              className="block px-3 py-2.5 text-sm rounded-lg text-foreground-600 hover:bg-foreground-50"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}